module.exports = __webpack_public_path__ + "videos/harmony_tab.4f05afb.mp4";